<template>
  <div class="col backgroundForm">
  
  <div class="form-row" >
    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mViewMap" :disabled="animate" ><font-awesome-icon icon="sync-alt" :spin="animate" /> Ver Ordops en Ejecución</button>
    </div>                        
  </div>

    <div class="row">
      <div class="col-12 col-md-8">
        <CargarMapa v-if="renderComponent"
          :configMapa="configMapa"
          apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
        >

          <template slot-scope="{ google, map }">
            <Marcadores
              v-for="marker in cLocationCaptains"
              :key="marker.id"
              :marker=marker
              :google="google"
              :map="map"
            />
          </template>

        </CargarMapa>
      </div>
      <div class="col-12 col-md-4" v-if="tables_color !== null" v-html="tables_color">
        
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';

  import CargarMapa from "./LoadMap";
  import Marcadores from "./MarksMaps";
  

  import { configMapa } from "@/constants/configMapaRead";
  import MarksMapsVue from './MarksMaps.vue';

  import capitania_menor from '@/assets/images/capitania_menor.png'
  import capitania_mayor from '@/assets/images/capitania_mayor.jpg'
  import base_naval from '@/assets/images/base_naval.jpg'
  import pma from '@/assets/images/pma.jpg'
  import oscar from '@/assets/images/oscar.png'
  

  export default {
    components: {
      CargarMapa,
      Marcadores
    },
    created(){
      this.mAsyncCallTemp(true);

    },
    mounted(){
      this.mCallOrdops();
      this.callCaptains();
    },
    beforeDestroy(){
      console.log('destruyendo el interval')
      // this.counter=null;
      // clearInterval(this.counter);
      this.mAsyncCallTemp(false);

    },
    data() {
      return {
        showMap:false,
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_select:-1,
        orvigent:[],
        types_ordop:[],
        tables_color:null,
        results_color:[],
        count_results_ordops:[],
        animate:false,
        counter:null
      };
    },
    methods:{
      mAsyncCallTemp(autocarga){
        if(autocarga){
          this.counter = setInterval(()=>{
            this.mViewMap();
            console.log('Actualizando el mapa cada 45 min')
          },2700000)
        }else{
          clearInterval(this.counter);
        }
        
      },
      async mCallOrdops(){
        let od=await axios.get(`globals/ordopinit?api_token=${Vue.auth.getToken()}`);
        let cro=await axios.get(`ordopsVigents?api_token=${Vue.auth.getToken()}`);

        // console.log(od);
        // console.log(cro.data);
        this.animate=true;
        this.count_results_ordops=cro.data;
        this.types_ordop=od.data;
        setTimeout(() => {
          this.animate=false;
          
        }, 3000);   
      },
      mViewMap(){
        this.animate=false;
        this.showMap=false;
        this.callCaptains();
        this.mCallOrdops();
        setTimeout(()=>{
          this.mGenerateMark();
          this.showMap=true;
          this.forceRerender();        

        }, 2000)
      },
      mConvertRadial(coord=-1){
                
        let coordenada_aux=coord<0 ? coord * -1: 0;

        let entero=0;
        let minuto=0;
        let minuto_aux=0;
        let segundo=0;

        let coordenada_end=null;

        entero=Math.trunc(coordenada_aux);
        minuto_aux=coordenada_aux-entero;
        minuto=Math.trunc(minuto_aux*60);

        segundo=Math.trunc((minuto-minuto_aux)*60);

        coordenada_end=`${entero}° ${minuto}' ${segundo}''`;
        return coordenada_end;

      },
      forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
            });
      },
      async callCaptains(){
        
        let cp=await axios.get(`getOrdopsMap?api_token=${Vue.auth.getToken()}`);
        let ordopsVigent=await axios.get(`getOrdopVigent?api_token=${Vue.auth.getToken()}`);
        // console.log(ordopsVigent);
        // console.log(cp.data);
        // let orvig_aux=ordopsVigent.data;

        this.ports=cp.data;
        this.orvigent=ordopsVigent.data;
         
      },
      mCallIcono(short_distrit, category){
        let ic_aux;
            switch(category){
                case 'CAPITANIA DE PUERTO MAYOR':
                  ic_aux=capitania_mayor;
                break;
                
                case 'CAPITANIA DE PUERTO MENOR':
                  ic_aux=capitania_menor;
                break;
                
                default:
                  ic_aux=oscar;
                break;
            }
        return ic_aux;
      },
      genHexColor(){
        let colors = new Array(16);
        colors[0]="0";
        colors[1]="1";
        colors[2]="2";
        colors[3]="3";
        colors[4]="4";
        colors[5]="5";
        colors[6]="6";
        colors[7]="7";
        colors[8]="8";
        colors[9]="9";
        colors[10]="a";
        colors[11]="b";
        colors[12]="c";
        colors[13]="d";
        colors[14]="e";
        colors[15]="f";

        let digit = new Array(5);
        let color="";
        for (let i=0;i<6;i++){
            // digit[i]=colors[Math.round(Math.random()*16)];
            color = color+colors[Math.round(Math.random()*15)];
        }

        return color;
      },
      mDateMilitary(d, c='/', h){
            let ft=d.split(c);
            let nfm;
            if(c==='/'){
                nfm=`${ft[0]}${h}/${ft[1]}/${ft[2]}`;
            }else{
                nfm=`${ft[2]}${h}/${ft[1]}/${ft[0]}`;
            }
            return nfm;
      },
      mAssignColorOrdops(){
        this.results_color=[];
        this.types_ordop.forEach(to=>{
          let indice=this.count_results_ordops.findIndex(val => val.id_tipo_ordop === to.id );

          let cantidad= indice>=0 ? this.count_results_ordops[indice].count:0;
          // console.log(`${to.id} es igual a ${cantidad}`);
            
            let colt={
              color:this.genHexColor(),
              type:to.id,
              detail:to.detail,
              cantidad: cantidad
            }

            this.results_color.push(colt);
        })
      },
      mGenerateTableColor(){
        // console.log(this.results_color);
        this.tables_color=null;
        setTimeout(() => {
          let tba=`<table class="table table-sm">
                  <tbody>`;
          this.results_color.forEach(dt =>{
            tba+=`<tr>
                    <td>${dt.detail}</td>
                    <td>${dt.cantidad}</td>
                    <td width="5%" style="background-color:#${dt.color}"></td>
                  </tr>`;
          });
          tba+=`</tbody>
          </table>`;
          this.tables_color=tba;  
        }, 1000);
        
      },
      mGenerateMark(){
        this.mAssignColorOrdops();
        this.$store.dispatch('sGoogleMaps/deleteMarkersCaptains', true);
        let marksCaptain=[];
        this.mGenerateTableColor();
        console.log(this.ports);

        if(this.ports.length > 0){
          this.ports.forEach((cap, index) => {                      
                let ic_aux=this.mCallIcono(cap.short_distrit, cap.category_port);
                let w_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 40:40;
                let h_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 30:40;
                
                let lat=this.mConvertRadial(cap.latitud);
                let lon=this.mConvertRadial(cap.longitud);
                
                let ordops_temp=cap.ordops;
                let cant_ordop=ordops_temp.length;

                // foreach de todas las ordops
                let text_ordop='';
                ordops_temp.forEach((odr, index)=>{
                  // console.log(odr.ejecucion_vigente);
                  let indexColor=this.results_color.findIndex(val => val.type === odr.id_tipo_ordop );
                      // console.log(indexColor);
                      // console.log(odr.id_tipo_ordop)
                  let hmt=this.mDateMilitary(odr.fecha_inicio, '-', odr.hora_inicio)
                  // revisar este bug del color que no esta encontrando
                  // let colorPoint=this.results_color[indexColor].color;
                  let colorPoint='#fff';
                  let temp_aux=`<div><span style="background-color:#${colorPoint}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> ${odr.titulo_ordop} <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; INICIO FH: ${hmt} </div>`;
                    text_ordop+=temp_aux;
                  
                })

                let location={
                  id:index,
                  position:{lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)},
                  icon:ic_aux,
                  size:{width:w_aux, height:h_aux},
                  title:`${cap.category_port} ${cap.name_port}`,
                  
                  description:`<div id="content" class="card">
                                <div class="card-body">
                                  <h6 class="card-title">${cap.category_port} ${cap.name_port}</h6>
                                  <p class="card-text"><b>Distrito:</b> ${cap.distrito}</p>
                                  <p class="card-text"><b>Departamento:</b> ${cap.departament}</p>
                                  <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                                  <p class="card-text"><b>No. Ordops:</b> ${cant_ordop} </p>
                                  <p class="card-text" >${text_ordop}</p>
                                
                                  </div>
                              </div>`,
                  jurisdiccion:[]
                }
                marksCaptain.push(location);
                // location.jurisdiccion.push({lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)});
                this.orvigent.forEach( (cpp,index) =>{
                    let caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
                    let code=caracteres.charAt(Math.floor(Math.random()*caracteres.length)) + caracteres.charAt(Math.floor(Math.random()*caracteres.length))+index;
                    if(cpp.id_capitania===cap.id){
                      // let aux={lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)}
                      // location.jurisdiccion.push(aux);
                      let lat=this.mConvertRadial(cpp.latitud);
                      let lon=this.mConvertRadial(cpp.longitud);

                      let location={
                      id:code,
                      position:{lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)},
                      icon:oscar,
                      size:{width:20, height:32},
                      title:`${cap.category_port} ${cap.name_port}`,
                      description:`<div id="content" class="card">
                                    <div class="card-body">
                                      <h6 class="card-title">${cap.category_port} ${cap.name_port}</h6>
                                      <p class="card-text"><b>ORDOP:</b> ${cpp.titulo_ordop}</p>
                                      <p class="card-text"><b>Localidad:</b> ${cpp.localidad}</p>
                                      <p class="card-text"><b>Descripción:</b> ${cpp.descripcion}</p>
                                      <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                                    </div>
                                  </div>`,
                      jurisdiccion:[]
                    }
                    marksCaptain.push(location);
                  }
                })
              });

          this.$store.dispatch('sGoogleMaps/addMarkersCaptains', marksCaptain);
        }else{
          toastr.info(`No Existe ORDOPS en Ejecucion`, `Sin registros`);
          this.animate=false;
        }
        
      },
      
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cLocationCaptains(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getMarkersCaptain'];
        // return this.$store.getters['sGoogleMaps/getLocation'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cLocationCaptains[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/maps/MapsCaptainViewOrdopVigent.vue